import { gql } from '@apollo/client';

export type {
  SignUpPartner as ISignUpPartner,
  SignUpPartnerVariables as ISignUpPartnerVariables,
} from './__generated__/SignUpPartner';

export const SIGN_UP_PARTNER = gql`
  mutation SignUpPartner(
    $partnerUser: PartnerUserInput!
    $channel: SlackChannel!
    $message: [SlackMessageField!]!
  ) {
    createPartnerUser(input: $partnerUser)
    postSlackMessage(channel: $channel, message: $message)
  }
`;
